module.exports = __webpack_public_path__ + "static/img/materialsInfo16.a91d70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo16.png
// module id = gbB7
// module chunks = 2